import React, { memo, useCallback, useMemo } from 'react';
import { IntegrationService } from '@business/services';

export interface PhoneActionsProps {
  phone: string;
  avatarBox?: boolean;

  objectId?: string; // Deal/Org/Project/TimeMaterial ID
  objectType?: string; // 'deal', 'organization', 'project', 'timeMaterial', 'order'
  contactId?: string;
}

export const PhoneActions = memo((props: PhoneActionsProps) => {
  const { phone, avatarBox = true, objectId, objectType, contactId } = props;
  const isRCActive = useMemo(() => IntegrationService.isRingCentralEnabled(), []);

  const onCall = useCallback(() => {
    if (objectId && objectType) {
      (window as any).rcCallContext = {
        objectId,
        objectType,
        contactId,
      };
    }

    try {
      (RCAdapter as any).clickToCall(phone);
    } catch (e) {}
  }, [phone, objectId, objectType, contactId]);

  const onSMS = useCallback(() => {
    if (objectId && objectType) {
      (window as any).rcSmsContext = {
        objectId,
        objectType,
        contactId,
      };
    }

    try {
      (RCAdapter as any).clickToSMS(phone);
    } catch (e) {}
  }, [phone, objectId, objectType, contactId]);

  return (
    <div className="d-flex flex-row ml-2">
      <a href={isRCActive ? undefined : `tel:+${phone}`} onClick={onCall} className="ml-1">
        {!!avatarBox && (
          <div className="avatar-xs">
            <span className="avatar-title rounded-circle bg-soft-success text-success font-size-18">
              <i style={{ fontSize: 12 }} className="fa fa-phone"></i>
            </span>
          </div>
        )}
        {!avatarBox && <i style={{ fontSize: 12 }} className="fa fa-phone text-success pl-1"></i>}
      </a>
      <a href={isRCActive ? undefined : `sms:${phone}`} className="ml-1" onClick={onSMS}>
        {!!avatarBox && (
          <div className="avatar-xs">
            <span className="avatar-title rounded-circle bg-soft-info text-info font-size-18">
              <i style={{ fontSize: 12 }} className="fa fa-comment-alt"></i>
            </span>
          </div>
        )}
        {!avatarBox && <i style={{ fontSize: 12 }} className="fa fa-comment-alt text-info pl-1"></i>}
      </a>
    </div>
  );
});
